/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { priceStyles } from "@monsma/Overrides/Widgets/ProductDetails/ProductDetailsPrice";
import { css } from "styled-components";

(priceStyles as any).productListPrice = {
    variant: "h5",
    color: "common.ui10",
    lineHeight: "20px",
    css: css`
        margin-bottom: 5px;
    `,
};

(priceStyles as any).msrp = {
    lineHeight: "22px",
    size: "13px",
    weight: 400,
    css: css`
        margin-left: 5px;
    `,
};

priceStyles.productPrice = {
    priceWrapper: {
        css: css`
            display: flex;
            align-items: flex-end;
            flex-flow: row wrap;
            ${wrapInContainerStyles};
        `,
    },
    price: {
        priceText: {
            variant: "h3",
            color: "secondary.main",
            lineHeight: "30px",
            css: css`
                margin-bottom: 0;
                flex: 0 0 auto;
            `,
        },
        unitOfMeasureText: {
            color: "common.ui23",
            lineHeight: "26px",
            size: "15px",
        },
    },
    quoteMessageWrapper: {
        css: css`
            line-height: 1;
        `,
    },
    quoteMessage: {
        text: {
            css: css`
                margin-right: 5px;
            `,
        },
    },
};

(priceStyles as any).productPriceReplcement = {
    variant: "h3",
    color: "secondary.main",
    lineHeight: "30px",
    css: css`
        margin-bottom: 0;
        display: flex;
        align-items: center;

        span {
            line-height: 26px;
            font-size: 15px;
            white-space: nowrap;
            font-weight: 400;
            margin-left: 5px;
        }
    `,
};

priceStyles.xProductDetailsPriceStyles = {
    productUnitOfMeasureSelectStyles: {
        cssOverrides: {
            formField: css`
                margin-top: 6px;
            `,
        },
    },
};
